<template>
    <div class="privacy-consent-component flex">
        <input v-model="checked" id="privacy-consent" class="absolute" type="checkbox">
        <label for="privacy-consent" class="flex items-center">
            <div class="checkbox flex flex-shrink-0">
                <img class="m-auto" v-show="checked" src="/img/done-green-18dp.svg">
            </div>
            <p class="text-left ml-3">By sending my data, I confirm that I have read and accept the <a class="font-semibold" target="_blank" href="https://cinergiapower.com/en/legal-notice-and-privacy-policy">privacy policy</a>.</p>
        </label>
    </div>
</template>

<script>
export default {
    data() {
        return {
            checked: false,
        }
    },

    watch: {
        checked(checked) {
            this.$emit('update:checked', checked);
        }
    },
}
</script>

<style scoped lang="scss">
@import '../../../sass/_variables';

input[type="checkbox"] {
    visibility: hidden;
}
input[type="checkbox"] + label {
    display: block;
    cursor: pointer;
    user-select: none;
    p:first-child {
        padding-left: 1rem;
        margin-left: -1rem;
    }
}
.checkbox {
    border: 1px solid #a0a0a0;
    border-radius: 4px;
    width: 20px;
    height: 20px;
    background: white;
}
a {
    color: black !important;
}
</style>
